import React, { Component } from 'react';
import "./subQa.css";
import SubArab from './subArab';

export class subQa extends Component {
  render() {
    return (
        <div className='container'>
          <div className="row">
          <div className="col-6">
              <form action="">
                <input type="search" className='choose_searchbox' placeholder="choose clients" />
              </form>
            </div>
            <div className="col-6">
              <form action="">
                <input type="search" className='choose_searchbox' placeholder="choose project" />
              </form>
            </div>
          </div>
        <div className="container usermain subQafirstsec">
        <div className="row">
          <div className="col-1">
            <div className="userlogo">
              {/* <img src={Usersiconimg} alt="" className="userlogoicon" /> */}
            </div>
          </div>

          <div className="col-11">
            <div className="usersearchsec subtitlemainmarginbottom">
                <span className="subqafontsizemaintitle">Arab Electricians</span>
            </div>
            <div className="usersearchsec subtitlemainmargintop">
                <span className="subqatitlefontsize">Shining tower</span>
                <form action="">
                    <input type="search" placeholder="Search" className="usersearch" />
                </form>
            </div>
            {/* activity section  */}
            < SubArab />
          </div>
        </div>
        </div>
      </div>
    )
  }
}

export default subQa;